var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags.length !== 0)?_c('div',_vm._l((_vm.tags),function(tag){return _c('span',{key:tag.id,staticClass:"ma-1"},[_c('faq-tag',{attrs:{"tag":tag,"small":""}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }